/**
 * UI fallbacks for AI Features settings. Catalog data comes from {@code GET /api/v2/ai/features/list}.
 */

/** {@code PricingFeaturesEntity.statusControlType} — Settings → AI Features Status column fallback. */
export const AI_FEATURE_STATUS_CONTROL_TYPES = Object.freeze({
    TOGGLE: "toggle",
    MANAGED_BY_AI_AGENT: "managed_by_ai_agent",
});

/** {@code AddonUsageConstants.AiAddonPricingFeature.TRIGGER} — always enabled; switch is read-only in listing. */
export const AI_ADDON_TRIGGER_FEATURE_FLAG = 105;

/** {@code AddonUsageConstants.AiAddonPricingFeature.REPHRASE} */
export const AI_ADDON_REPHRASE_FEATURE_FLAG = 100;

/** {@code AddonUsageConstants.AiAddonPricingFeature.AUTO_REPLY} */
export const AI_ADDON_AUTO_REPLY_FEATURE_FLAG = 101;

/** {@code AddonUsageConstants.AiAddonPricingFeature.MESSAGE_REPLY_SUGGESTION} */
export const AI_ADDON_MESSAGE_SUGGESTION_FEATURE_FLAG = 104;
